<template>
	<div id="app">
		<router-view />
		<pre class="ascii-art">{{ asciiArt }}</pre>
	</div>
</template>
  
<script>
	import axios from 'axios'
	
	// Use the same domain as the current page, with port 8000 for backend (dev) or same origin for production
	const API_BASE = process.env.NODE_ENV === 'production' 
		? window.location.origin  // In production, use same origin (nginx proxies to backend)
		: window.location.protocol + '//' + window.location.hostname + ':8000'  // In dev, use port 8000
	
	// Create axios instance with base URL
	const api = axios.create({
		baseURL: API_BASE
	})
	
	export { api }
	
	// Utility function for formatting dates
	export function formatDate(dateString) {
		if (!dateString) return 'N/A'
		const date = new Date(dateString)
		return date.toLocaleString('ru-RU', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		})
	}
	
	export default {
		name: 'App',
		data() {
			return {
				asciiArt: ''
			}
		},
		async mounted() {
			document.title = 'Firebird';
			try {
				const response = await fetch('/firebird.ascii')
				this.asciiArt = await response.text()
			} catch (error) {
				console.error('Failed to load ASCII art:', error)
			}
		}
	}
</script>
  
<style>
	* {
		font-family: monospace;
	}
	
	html, body {
		margin: 0;
		padding: 0;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		min-height: 100vh;
		position: relative;
		overflow: hidden;
		margin: 0;
		padding: 0;
	}

	.ascii-art { 
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
  
		/* Styling - responsive font size that scales with viewport */
		font-size: clamp(1.5px, 1.2vw, 8px);
		text-align: center;
		color: #2c3e50;
		
		/* Positioning */
		z-index: -1;
		pointer-events: none;
		user-select: none;
		white-space: pre-wrap;
		
		/* Responsive - ensures it fits all screen sizes */
		width: 100%;
		max-width: 100vw;
		max-height: 100vh;
		overflow: hidden;
		word-wrap: break-word;
		box-sizing: border-box;
		padding: 0 clamp(5px, 2vw, 20px);
	}
</style>